"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var KEYCODE = __importStar(require("../../config"));
var calNewIndex_1 = __importDefault(require("../../helperFns/calNewIndex"));
var HandleFnsByKeyCode = /** @class */ (function () {
    function HandleFnsByKeyCode() {
    }
    HandleFnsByKeyCode.confirmOrEscape = function (confirmFn, escapeFn) {
        return function (keyCode) {
            if (keyCode === KEYCODE.ENTER) {
                confirmFn();
            }
            else if (keyCode === KEYCODE.ESCAPE) {
                escapeFn();
            }
        };
    };
    HandleFnsByKeyCode.plusOrMinusIndex = function (keyCode) {
        return keyCode === KEYCODE.ARROW_UP ? calNewIndex_1.default('-') : calNewIndex_1.default('+');
    };
    return HandleFnsByKeyCode;
}());
exports.HandleFnsByKeyCode = HandleFnsByKeyCode;
exports.useFnsByKeyCode = function (_a) {
    var lastIndex = _a.lastIndex, confirmFn = _a.confirmFn, escapeFn = _a.escapeFn;
    var confirmFnNow = react_1.useRef();
    var _b = react_1.useState(0), index = _b[0], setIndex = _b[1];
    // const [confirmFnNow, setConfirmFn] = useState(() => confirmFn);
    var HandleFnsByKeyCodeEvent = react_1.useCallback(function (e) {
        var keyCode = e.keyCode;
        switch (keyCode) {
            case KEYCODE.ENTER:
            case KEYCODE.ESCAPE: {
                if (confirmFnNow.current) {
                    HandleFnsByKeyCode.confirmOrEscape(confirmFnNow.current, escapeFn)(keyCode);
                }
                ;
                break;
            }
            case KEYCODE.ARROW_UP:
            case KEYCODE.ARROW_DOWN: {
                var calculatedIndex = HandleFnsByKeyCode.plusOrMinusIndex(keyCode)({
                    lastIndex: lastIndex,
                    indexNow: index
                });
                setIndex(calculatedIndex);
                break;
            }
            default:
                break;
        }
    }, [confirmFnNow, escapeFn, lastIndex, index]);
    react_1.useEffect(function () {
        confirmFnNow.current = confirmFn;
    }, [confirmFn]);
    react_1.useEffect(function () {
        window.addEventListener('keydown', HandleFnsByKeyCodeEvent);
        return function () {
            window.removeEventListener('keydown', HandleFnsByKeyCodeEvent);
        };
    }, [HandleFnsByKeyCodeEvent]);
    return ({
        index: index,
    });
};
